if (!customElements.get("cart-drawer")) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector("#cart-icon-bubble");
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      setTimeout(() => {
        this.classList.add("animate", "active");
      });

      document.body.classList.add("overflow-hidden");
    }

    close() {
      this.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define("cart-drawer", CartDrawer);
}

function updateCartDrawer() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            console.log("Cart updated:", cart);

            // Update cart item count
            document.querySelectorAll(".cart-count").forEach(el => {
                el.textContent = cart.item_count;
            });

            // Force cart drawer reload
            fetch('/?sections=cart-drawer,cart-icon-bubble')
                .then(response => response.json())
                .then(data => {
                    if (data['cart-drawer']) {
                        document.querySelector('#CartDrawer').innerHTML = data['cart-drawer'];
                    }
                    if (data['cart-icon-bubble']) {
                        document.querySelector('#cart-icon-bubble').innerHTML = data['cart-icon-bubble'];
                    }
                });
        });
}

document.addEventListener("DOMContentLoaded", function () {
    function updateCartDrawer() {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                const cartDrawer = document.querySelector(".drawer-cart-items-wrapper"); // Ensure this is the correct selector
                
                if (!cartDrawer) return;

                // Clear current cart contents
                cartDrawer.innerHTML = "";

                // If cart is empty, show a message
                if (cart.items.length === 0) {
                    cartDrawer.innerHTML = `<p class="empty-cart-message">Your cart is empty.</p>`;
                } else {
                    // Rebuild cart items
                    cart.items.forEach(item => {
                        cartDrawer.innerHTML += `
                            <div class="cart-item" data-line="${item.key}">
                                <img src="${item.image}" alt="${item.product_title}">
                                <p>${item.product_title}</p>
                                <p>${(item.line_price / 100).toFixed(2)}</p>
                                <button class="cart-remove-button" data-line="${item.key}">Remove</button>
                            </div>
                        `;
                    });
                }

                // Update cart count on the header icon
                const cartCount = document.querySelector(".cart-count-bubble"); // Ensure this matches your cart count selector
                if (cartCount) {
                    cartCount.textContent = cart.item_count > 0 ? cart.item_count : "";
                }

                // Rebind remove button event listeners
                attachRemoveEventListeners();
            })
            .catch(error => console.error("Error updating cart:", error));
    }

    function attachRemoveEventListeners() {
        document.querySelectorAll(".cart-remove-button").forEach(button => {
            button.addEventListener("click", function (event) {
                event.preventDefault();
                const lineItemKey = this.getAttribute("data-line");
                if (!lineItemKey) return;
                
                fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: lineItemKey, quantity: 0 })
                })
                .then(response => response.json())
                .then(() => {
                    updateCartDrawer(); // Ensure cart drawer updates immediately
                })
                .catch(error => console.error("Error removing item:", error));
            });
        });
    }

    // Initialize remove button event listeners on page load
    attachRemoveEventListeners();
});
